export default __webpack_public_path__ + "static/media/Comp 2_00002.15f11890.png";